<template>
  <!-- Kanzlei Polz, Mail „Korrespondenz mit MDT" (16.10.2026): sichtbar
       machen, dass nicht mit dem Kunden selbst korrespondiert wird – mit wem
       und warum. Steht auf der Kundenkarte (Beteiligte) und im E-Mail-Fenster.
       Den Grund sieht nur die Kanzlei (18.10.2026); alle anderen sehen, DASS
       und mit wem korrespondiert wird. -->
  <aside
    v-if="notice"
    class="cn"
    :class="{ 'cn--incomplete': showReason && notice.reasonMissing }"
    role="note"
    :aria-label="$gt('Abweichende Korrespondenzperson')"
    data-testid="correspondence-notice"
  >
    <UserRoundCog :size="16" class="cn__icon" aria-hidden="true" />
    <div class="cn__body">
      <p class="cn__title">
        <template v-if="clientLabel">{{ clientLabel }}: </template>{{ $gt('Korrespondenz über') }} <strong>{{ notice.person }}</strong>
      </p>
      <p v-if="notice.contacts.length" class="cn__contacts">{{ notice.contacts.join(' · ') }}</p>
      <template v-if="showReason">
        <p v-if="notice.reasonMissing" class="cn__reason cn__reason--missing">{{ $gt('Grund fehlt – bitte in den Kundendaten vermerken.') }}</p>
        <p v-else class="cn__reason">{{ $gt('Grund') }}: {{ notice.reason }}</p>
      </template>
      <slot name="actions" />
    </div>
  </aside>
</template>

<script setup lang="ts">
import { UserRoundCog } from "lucide-vue-next";
import { computed } from "vue";
import { correspondenceNotice, type CorrespondenceFields } from "@/utils/correspondencePerson";

const props = withDefaults(
  defineProps<{
    client: CorrespondenceFields | null | undefined;
    /** Grund anzeigen – nur für die Kanzlei (canManageCorrespondence). */
    showReason?: boolean;
    /** Kundenname vor dem Hinweis, z. B. im E-Mail-Fenster bei mehreren Kunden. */
    clientLabel?: string;
  }>(),
  { showReason: true, clientLabel: "" },
);

const notice = computed(() => correspondenceNotice(props.client));
</script>

<style scoped>
.cn {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid #f2c94c;
  border-left-width: 4px;
  background: #fff8e1;
  color: #5c4100;
}
.cn--incomplete {
  border-color: #e0a100;
}
.cn__icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #b07d00;
}
.cn__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.cn__title,
.cn__contacts,
.cn__reason {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.cn__title strong {
  font-weight: 700;
}
.cn__contacts {
  color: #6b5200;
}
.cn__reason--missing {
  font-weight: 600;
  color: #8a4b00;
}
</style>
